"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var handleClick = function (href, onClick, preventDefault, e) {
    if (preventDefault && href === '#') {
        e.preventDefault();
        e.stopPropagation();
    }
    if (onClick) {
        onClick(e);
    }
};
/**
 * A reusable button. Uses a <a> tag underneath.
 */
var Button = function (_a) {
    var className = _a.className, children = _a.children, accessibleLabel = _a.accessibleLabel, href = _a.href, target = _a.target, preventDefault = _a.preventDefault, onClick = _a.onClick, dialogTrigger = _a.dialogTrigger;
    var hasText = children !== null;
    var accessibleElt = accessibleLabel ? (react_1["default"].createElement("span", { className: "visuallyhidden" }, accessibleLabel)) : null;
    return (react_1["default"].createElement("a", { className: className, onClick: handleClick.bind(null, href, onClick, preventDefault), rel: target === '_blank' ? 'noopener noreferrer' : null, href: href, target: target, "aria-haspopup": dialogTrigger ? 'dialog' : null }, hasText ? children : accessibleElt));
};
Button.propTypes = {
    href: prop_types_1["default"].string,
    className: prop_types_1["default"].string,
    target: prop_types_1["default"].string,
    children: prop_types_1["default"].node,
    accessibleLabel: prop_types_1["default"].string,
    onClick: prop_types_1["default"].func,
    isLoading: prop_types_1["default"].bool,
    preventDefault: prop_types_1["default"].bool,
    dialogTrigger: prop_types_1["default"].bool,
};
Button.defaultProps = {
    href: '#',
    className: '',
    target: null,
    children: null,
    accessibleLabel: null,
    onClick: null,
    isLoading: false,
    preventDefault: true,
    dialogTrigger: false,
};
exports["default"] = Button;
